import EcoLink from 'eco-design/base/eco-link';
import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { sendFormCommon } from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteForm/FormCommon/sendApis';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/i18n';
import { rpcMap } from '@/constants/lang';

const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;

const termsMap: { [key: string]: string[] } = {
    us: ['https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-us/TermsOfUse.html'],
    ca: ['https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-ca/TermsOfUse.html'],
    jp: ['https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html'],
    eu: ['https://account.ecoflow.com/agreement/en-eu/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-eu/TermsOfUse.html'],
    uk: ['https://account.ecoflow.com/agreement/en-ul/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-uk/TermsOfUse.html'],
    de: ['https://account.ecoflow.com/agreement/de-de/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/de-de/TermsOfUse.html'],
    fr: ['https://account.ecoflow.com/agreement/fr-fr/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/fr-fr/TermsOfUse.html'],
    it: ['https://account.ecoflow.com/agreement/it-it/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/it-it/TermsOfUse.html'],
    es: ['https://account.ecoflow.com/agreement/es-es/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/es-es/TermsOfUse.html'],
};

const PhoneInput: React.FC = ({}) => {
    const { t } = useLang('dpux');
    const [phone, setPhone] = useState('');
    const [tip, setTip] = useState('');
    const { locale } = getLocal();
    const [checkedPhone, setCheckedPhone] = useState(false);

    const handleFoucus = () => {
        if ([t('D_tip_success_phone'), t('D_tip_phone_format'), t('D_tip_phone_empty')].includes(tip)) {
            setTip('');
        }
    };

    const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
        if ([t('D_tip_success_phone'), t('D_tip_unchecked_phone')].includes(tip)) {
            setTip('');
        }
        setCheckedPhone(e.target.checked);
    };

    // 人机验证
    const recaptchaRef = useRef();
    const hl = rpcMap[locale] || rpcMap['us'];
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const onReCAPTCHAChange = async (captchaCode: string) => {
        if (!captchaCode) return;
        setRecaptchaResponse(captchaCode);
        setTip('');
    };

    const handleSubmit = async () => {
        if (!phone) {
            return setTip(t('D_tip_phone_empty'));
        }
        if (!checkedPhone) {
            return setTip(t('D_tip_unchecked_phone'));
        }
        if (!recaptchaResponse) {
            return setTip(t('D_tip_recaptcha'));
        }
        const res = await sendFormCommon(
            {
                recaptchaResponse,
                phone,
                targetSystem: 'LEADS',
                source: 'DPU X',
            },
            locale,
        );
        if (res.code === '0') {
            setTip(t('D_tip_success_phone'));
            setPhone('');
            gtm.push({
                event: 'uaEvent',
                event_name: 'pre_order_submit',
                button_name: 'Submit_Phone',
                status: 'success',

                __btn_id1: 'dpux-D .phone-control .btn',
                __btn_id2: 'dpux-D-button-phone',
                __btn_type: 'common',
            });
        } else {
            setPhone('');
            gtm.push({
                event: 'uaEvent',
                event_name: 'pre_order_submit',
                button_name: 'Submit_Phone',
                status: 'fail',

                __btn_id1: 'dpux-D .phone-control .btn',
                __btn_id2: 'dpux-D-button-phone',
                __btn_type: 'common',
            });
        }
    };

    return (
        <div className={`control phone-control`}>
            <div className="subscribe">
                <div className="subscribe-input">
                    <div className="phone-prefix">+1</div>
                    <input
                        type="text"
                        className="input"
                        id="dpux-D-input"
                        placeholder={t('D_placeholder_phone')}
                        value={phone}
                        onInput={(e) => (e.target.value = e.target?.value?.replace?.(/[^\d]/g, ''))}
                        onChange={(e) => setPhone(e.target.value.trim())}
                        onFocus={handleFoucus}
                    />
                </div>
                <p className={`tip${tip ? ' show' : ''}${tip === t('D_tip_success_phone') ? ' success' : ''}`}>{tip}</p>
                <button className="btn GtmModuleData-btn-commo" data-btn-id="dpux-D-button-phone" onClick={handleSubmit}>
                    {t('D_btn_phone')}
                </button>
                {/* @ts-ignore */}
                <ReCAPTCHA ref={recaptchaRef} hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} theme={'dark'} />
            </div>
            <div className="terms">
                <input
                    type="checkbox"
                    className="checkbox GtmModuleData-btn-common"
                    id="dpux-D-checkbox"
                    checked={checkedPhone}
                    data-btn-id="dpux-D-checkbox-phone"
                    onChange={(e) => {
                        gtm.push({
                            __btn_id1: `dpux-D .phone-control .checkbox`,
                            __btn_id2: `dpux-D-checkbox-phone`,
                            __btn_type: 'common',
                        });
                        handleCheck(e);
                    }}
                />
                <label className="terms-text" htmlFor="dpux-D-checkbox">
                    {t.rich('D_terms_phone', {
                        l2: (privacyPolicy: string) => (
                            <EcoLink
                                className="terms-text-href2 GtmModuleData-btn-href"
                                dataLayer={{
                                    __btn_id1: `dpux-D .phone-control .terms-text-href2`,
                                    __btn_id2: termsMap[locale][0],
                                    __btn_type: 'href',
                                }}
                                href={termsMap[locale][0]}
                                target="_blank"
                            >
                                {privacyPolicy}
                            </EcoLink>
                        ),
                    })}
                </label>
            </div>
        </div>
    );
};
export default PhoneInput;
